import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { VertesiaErrorBoundary } from './VertesiaErrorBoundary';
export function WidgetErrorBoundary({ children }) {
    return (_jsx(VertesiaErrorBoundary, { fallback: WidgetErrorFallback, children: children }));
}
function WidgetErrorFallback({ error }) {
    console.log('WidgetError', error);
    return (_jsxs("div", { className: "text-sm", children: ["Sorry, this area cannot be loaded or rendered.", error?.message &&
                _jsx("pre", { children: error.message })] }));
}
//# sourceMappingURL=WidgetErrorBoundary.js.map